package com.eladfinish.bible.contest.ui.utils

import androidx.compose.ui.Modifier
import androidx.compose.ui.platform.testTag

actual fun Modifier.automationTag(tag: String) = testTag(tag)
